import React from 'react'
import { compose, withProps } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'

import { SelectField } from '.'

const query = gql`
  query {
    insurers {
      id
      name
    }
  }
`
const withQuery = graphql(query)

const InsurerSelectField = compose(
  withQuery,
  withProps(({ data: { loading, insurers = [] } }) => {
    const options = insurers.map(rec => ({ value: rec.id, label: rec.name }))
    return {
      isLoading: loading,
      options
    }
  })
)(SelectField)

export default props => (
  <React.Fragment>
    <FormControl fullWidth>
      <InputLabel shrink>Seguradora</InputLabel>
    </FormControl>
    <InsurerSelectField {...props} />
  </React.Fragment>
)
